import i18n from 'i18next';
import { z, ZodErrorMap, ZodIssueCode } from 'zod';

// Traduz as mensagens padrão do zod a cada validação, então trocar de idioma vale na hora.
export const zodErrorMap: ZodErrorMap = (issue) => {
    const t = (key: string, options?: Record<string, unknown>) => ({ message: i18n.t(`validacao.${key}`, options) });

    switch (issue.code) {
        case ZodIssueCode.invalid_type:
            return issue.received === 'undefined' || issue.received === 'null' ? t('obrigatorio') : t('tipoInvalido');

        case ZodIssueCode.invalid_string:
            if (issue.validation === 'email') return t('emailInvalido');
            if (issue.validation === 'url') return t('urlInvalida');
            return t('invalido');

        case ZodIssueCode.too_small: {
            const min = Number(issue.minimum);
            if (issue.type === 'string') return min <= 1 ? t('obrigatorio') : t('textoMinimo', { min });
            if (issue.type === 'array') return t('listaMinima', { min });
            if (issue.type === 'number') return t(issue.inclusive ? 'numeroMinimo' : 'numeroMaiorQue', { min });
            return t('invalido');
        }

        case ZodIssueCode.too_big: {
            const max = Number(issue.maximum);
            if (issue.type === 'string') return t('textoMaximo', { max });
            if (issue.type === 'array') return t('listaMaxima', { max });
            if (issue.type === 'number') return t(issue.inclusive ? 'numeroMaximo' : 'numeroMenorQue', { max });
            return t('invalido');
        }

        case ZodIssueCode.invalid_date:
            return t('dataInvalida');

        case ZodIssueCode.invalid_enum_value:
        case ZodIssueCode.invalid_literal:
        case ZodIssueCode.invalid_union:
            return t('opcaoInvalida');

        default:
            return t('invalido');
    }
};

z.setErrorMap(zodErrorMap);
